import commonStyle from "assets/jss/material-dashboard-pro-react/commonStyle";

const pickerStyle = {
    ...commonStyle,
    formControl: {
        marginTop: 12,
        marginBottom: 12,
    },
    pickerContainer: {
        flex: 1, 
        display: 'flex', 
        marginTop: 6, 
        position: 'relative'
    },
    colorPickerInput: {
        top: 0,
        left: 0,
        width: 80,
        height: 30,
        borderRadius: 0,
        opacity: 0,
        position: 'absolute',
        cursor: 'pointer',
        pointerEvents: 'all',
        zIndex: 1,
    },
    colorPickerLabel: {
        lineHeight: '1 !important',
        fontSize: '0.75rem',
        fontWeight: 400,
        color: 'rgba(0, 0, 0, 0.54)'
    },
    colorPickerBox: {
        display: 'inline-flex',
        width: 50,
        height: 30,
        borderRadius: '3px 0 0 3px',
        borderStyle: 'solid',
        borderWidth: 1,
    },
    colorPickerButton: {
        width: 30,
        height: 30,
        borderRadius: '0 3px 3px 0',
        padidng: 0,
        margin: 0
    },
    hexInput: {
        width: 100,
        height: 30,
        marginLeft: 10,
        marginTop: 5
    },
    inputContainer: {
        display: 'flex',
        alignItems: 'center',
      },
    hashSymbol: {
        color: 'gray',
        marginLeft: 10,
        marginRight: -8,
        marginBottom: 6
    },
};

export default pickerStyle;
